import * as Yup from "yup";
import { ContraparteSchema } from "../contraparte";
import { ContraparteCCEE } from "./model";

export class ContraparteCCEESchema {
  public static id() {
    return Yup
      .number()
      .positive("Id deve ser um numero positivo");
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static createForm() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static updateForm() {
    return Yup
      .object()
      .shape(recordShape);
  }
}

const recordShape: Partial<Record<keyof ContraparteCCEE, any>> = {
  idCCEE: Yup.string(),
  fonteCCEE: Yup.string(),
  agenteCCEE: Yup.string(),
  contraparte: Yup.object().shape({
    id: ContraparteSchema.id(),
  }),
};
